import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import CrumbName from './CrumbName';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_RIGHT__12} from '@homeaway/svg-defs';

class LinkedCrumb extends Component {
    static propTypes = {
        currentPage: PropTypes.bool,
        hasDivider: PropTypes.bool,
        name: PropTypes.string.isRequired,
        onClickName: PropTypes.func.isRequired,
        position: PropTypes.number.isRequired,
        url: PropTypes.string.isRequired,
        node: PropTypes.node
    };

    renderName = () => {
        const {name, onClickName, position} = this.props;

        return (
            <Fragment>
                <CrumbName name={name} onClick={onClickName}/>
                <span itemProp="position" content={position} aria-hidden/>
            </Fragment>
        );
    };

    renderLink = () => {
        const {currentPage, node, url, name} = this.props;
        const aProps = {
            ...(currentPage && {'aria-current': 'page'}),
            ...(!node && {href: url}),
            className: 'Breadcrumb__a',
            title: name,
            itemProp: 'item'
        };

        /* For the most part, this is assuming `node` is a Link component from react-router-dom.
        * Other use cases' success may vary.  (Note that we don't pass href in link.node as Link uses `to` prop)
        */
        if (node) {
            return (React.cloneElement(
                node, {
                    ...aProps
                },
                this.renderName()
            ));
        }

        return (
            <a
                {...aProps}
            >
                {this.renderName()}
            </a>
        );
    };

    render() {
        const {hasDivider} = this.props;

        return (
            <li className="Breadcrumb__li" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                {this.renderLink()}

                {hasDivider && <SVGIcon markup={CHEVRON_RIGHT__12} inlineFlex className="Breadcrumb__divider" aria-hidden/>}
            </li>
        );
    }
}

export default LinkedCrumb;
